import EventDetailsTabs from 'features/events/components/event-details-form/event-details-tabs';
import { useParams } from 'react-router-dom';

export const EventDetailsView = () => {
  const { id } = useParams();

  if (!id) return null;

  return <EventDetailsTabs />;
};
